import './print.scss'
import icon from './print.svg'

/**
 * Print base route.
 *
 * @namespace routes.OperationPrint
 * @type {TmrRoute}
 */
export const route = {
  name: 'operations.print',
  // Default print tab.
  redirectTo: $transition$ => {
    const TmrPrint = $transition$.injector().get('TmrPrint')
    const [firstPrintOperation] = TmrPrint.getPrintOperations()
    if (firstPrintOperation) return firstPrintOperation.name
  },
  label: 'OPERATIONS.PRINT.TITLE',
  accessControl: ['Operation.perform', 'Operation.Print.perform'],
  weight: 1,
  icon,
}
